import React from 'react';
import { HandIcon, ShieldCheckIcon } from 'lucide-react';
import { PRODUCT_PRICE, formatPrice } from '../data/config';
import { CtaButton } from './CtaButton';
import { ProductImage } from './ProductImage';
type FinalCTAProps = {
  guaranteeEnabled: boolean;
};
export function FinalCTA({
  guaranteeEnabled
}: FinalCTAProps) {
  return <section className="bg-blue-950 px-4 py-6 text-center md:px-12 md:py-8" data-id="element-60" data-mp="83vwxc2bzm21">
      <h2 className="text-[24px] font-extrabold uppercase leading-[1.15] tracking-[-0.3px] text-amber-400 md:text-[29px]" data-id="element-61" data-mp="m3x04y62j5ko">
        One last question
      </h2>
      <p className="mx-auto mt-2 max-w-[580px] text-[16px] font-bold leading-[1.35] text-white md:text-[19px]" data-id="element-62" data-mp="vui5d4g8z8ck">
        How often do you need to search different resources to find the right pediatric OT activity?
      </p>
      <p className="mx-auto mt-2 max-w-[580px] text-[14px] leading-[1.45] text-blue-200 md:text-[15px]" data-id="element-63" data-mp="14uogijoh3w8k">
        One resource for fine motor, another for handwriting, another for self-care — plus separate files for sessions,
        observations, and printables. Keep working with disconnected resources, or bring them together in one organized
        professional collection.
      </p>
      <p className="mt-2 text-[13px] font-extrabold uppercase text-amber-400 md:text-[14px]" data-id="element-64" data-mp="2m2b4ko5dl19p">
        Identify. Select. Implement. Adapt. Review.
      </p>

      <div className="mx-auto mt-3 max-w-[240px]" data-id="element-65" data-mp="2qzug3gaouzxy">
        <ProductImage data-id="element-66" data-mp="2v4ak1c0qrxaj" />
      </div>

      <h3 className="mx-auto mt-2 max-w-[600px] text-[22px] font-extrabold uppercase leading-[1.1] tracking-[-0.3px] text-white md:text-[28px]" data-id="element-67" data-mp="2v38ww96gbkcg">
        <HandIcon className="mr-1.5 inline h-6 w-6 -translate-y-0.5 text-teal-300" strokeWidth={2.5} aria-hidden data-id="element-68" data-mp="34tloglcoods3" />
        Pediatric OT Complete Therapy System™
      </h3>
      <p className="mt-1.5 text-[13px] font-extrabold uppercase text-teal-300 md:text-[14px]" data-id="element-69" data-mp="39u9gnacnf0nw">
        6 Volumes + 5 FREE Bonuses • 440 pages
      </p>
      <p className="mt-3 text-[13px] font-extrabold uppercase leading-tight text-white md:text-[14px]" data-id="element-70" data-mp="3iu4xnvsvxpvu">
        Get the complete system today for only
      </p>
      <p className="mt-1 text-[42px] font-extrabold leading-none tracking-[-1px] text-amber-400 md:text-[50px]" data-id="element-71" data-mp="1ep8rxw65riaf">
        {formatPrice(PRODUCT_PRICE)} <span className="text-[18px] tracking-normal text-white md:text-[20px]" data-id="element-72" data-mp="1shou6ur8jcaa">USD</span>
      </p>
      <div className="mt-3" data-id="element-73" data-mp="1novq893lc7z9">
        <CtaButton mode="checkout" data-id="element-74" data-mp="1nnu4naoy833a">Yes! I want the complete pediatric OT system!</CtaButton>
      </div>
      <p className="mt-2 text-[12px] font-semibold text-blue-200 md:text-[13px]" data-id="element-75" data-mp="22gxmlj6gciuj">
        {guaranteeEnabled && <ShieldCheckIcon className="mr-1 inline h-3.5 w-3.5 -translate-y-px text-teal-300" aria-hidden data-id="element-76" data-mp="2bfj2f6kjhjrm" />}
        Instant Digital Access{guaranteeEnabled && ' • 7-Day Money-Back Guarantee'}
      </p>
    </section>;
}